import { createSelector } from 'reselect'

import { RootState } from '../../data/store'

export const getProviders = (state: RootState) => state?.providers

export const getProvidersDetails = createSelector(getProviders, (providers) => providers?.providerDetails)

export const getProviderPaymentHistoryDownload = createSelector(
  getProvidersDetails,
  (providerDetails) => providerDetails?.paymentHistoryDownload,
)

export const getProviderDetailsData = createSelector(getProvidersDetails, (providersDetails) => providersDetails?.data)

export const getProviderDetailsAddresses = createSelector(getProviderDetailsData, (data) => data?.addresses)

export const getProviderDetailsRates = createSelector(getProviderDetailsData, (data) => data?.rates)

export const getProviderDetailsDiffPricingEnabled = createSelector(
  getProviderDetailsData,
  (data) => data?.differential_pricing_enabled,
)

export const getProviderDetailsDiffPricingModifier = createSelector(
  getProviderDetailsData,
  (data) => data?.differential_pricing_in_person_modifier,
)

export const getProviderDetailsCalendarState = createSelector(getProviderDetailsData, (data) => data?.calendar_state)

export const getProviderModalities = createSelector(getProviderDetailsData, (data) => data?.modalities)

const getProvidersRegister = createSelector(getProviders, (providers) => providers?.register)

export const getProvidersRegisterAccountType = createSelector(getProvidersRegister, (register) => register?.accountType)

export const getProvidersData = createSelector(getProviders, (providers) => providers?.data)

export const getProviderFullName = createSelector(
  getProviderDetailsData,
  (getProvidersData) => getProvidersData?.full_name,
)

export const getProvidersList = createSelector(getProvidersData, (providersData) => providersData?.providersList)

export const getProvidersIsDownloadingCSV = createSelector(
  getProvidersData,
  (providersData) => providersData?.isDownloadingCSV,
)
